// import jQuery from 'CommonScripts/jquery-1.10.2';
import overlayDialog from './overlayDialog';


// modal specifications only for the checkbox spot; name and call it from the spot's js 
(function (window, document, $) {
    $(document).ready(function () {
        var dataSent = '?';

        function getNumberOfCurrentlySelectedBrochures(group) {
            var currentlyChecked = 0;
            $("input[data-cgroup$=" + group + "]").each(function () {
                if (this.checked) {
                    currentlyChecked++;
                } else {
                    var parsedValue = parseInt(this.value);
                    if (parsedValue) {
                        currentlyChecked += parsedValue;
                    }
                }
            });
            return currentlyChecked;
        }

        function check_with_group(currentlySelected, limit, e_message, isNumberInputType, input) {
            if (!(limit == '' || limit == 0)) {
                if (currentlySelected > limit) {
                    if (typeof Sitecore == "undefined") {
                        if (isNumberInputType) {
                            var diff = currentlySelected - limit;
                            input.value -= diff;
                        } else {
                            $(input).prop('checked', false);
                        }
                        return false;
                    }
                }
            }
        }

        function validateInputNumber(numericValue, input) {
            if (numericValue) {
                var minValue = parseInt($(input).attr("min"));
                var maxValue = parseInt($(input).attr("max"));
                numericValue = Math.max(numericValue, minValue);
                if (maxValue) {
                    var warningTxt = $(input).attr("data-maxwarningmsg");
                    if (warningTxt && numericValue > maxValue) {
                        overlayDialog.show('<div id="blankcontent"><div style="width:300px; margin-left:10px; margin-bottom:10px;">' + warningTxt + '</div></div>');
                    }

                    numericValue = Math.min(numericValue, maxValue);
                }
                input.value = numericValue;
            } else {
                input.value = "";
            }
            return numericValue;
        }

        $(".g_checkbox").on('input', function () {
            var isNumberInputType = $(this).attr("type")=="number";
            var numericValue = parseInt(this.value);
            if (isNumberInputType) {
                numericValue = validateInputNumber(numericValue, this);
            }

            var this_checked = this.checked;
            var this_group = $(this).attr("data-cgroup");
            var this_limit = $(this).attr("data-climit");
            var this_message = $(this).attr("data-errMsg");
            var this_name = $(this).attr("name");

            var currentlySelected = getNumberOfCurrentlySelectedBrochures(this_group);

            var validCheck = check_with_group(currentlySelected, this_limit, this_message, isNumberInputType, this);
            if (validCheck == false) {
                overlayDialog.show('<div id="blankcontent"><div style="width:300px; margin-left:10px; margin-bottom:10px;">' + this_message + '</div></div>');
            }

            numericValue = parseInt(this.value);
            this_checked = this.checked;

            var replacingRegex = new RegExp(this_name + '=' + '(-?[0-9]+|checked)' + '&');
            dataSent = dataSent.replace(replacingRegex, '');
            if (this_checked) {
                dataSent += this_name + '=' + "checked" + '&';
            } else if (numericValue) {
                dataSent += this_name + '=' + numericValue + '&';
            }

        });

        $("#submit_checkbox").on('click', function () { // button identifier required for the click call on the submit button
            var checkLimitReach = true;
            var _href = $("#submit_checkbox").attr("href");
            $(".g_checkbox").each(function () {
                var this_group = $(this).attr("data-cgroup");
                var this_lowLimit = $(this).attr("data-llimit");
                var currentlyChecked = getNumberOfCurrentlySelectedBrochures(this_group);
                if (!(this_lowLimit == 0 || this_lowLimit == '')) {
                    if (currentlyChecked < this_lowLimit) {
                        checkLimitReach = false;
                    } else {
                            checkLimitReach = true;
                    }
                }
            });
            
            if (!checkLimitReach) {
                if (typeof Sitecore == "undefined") {
                        overlayDialog.show('<div id="blankcontent"><div style="width:300px; margin-left:10px; margin-bottom:10px;">' + jQuery('.g_checkbox').attr("data-errmsgrequired") + '</div></div>');
                        return false;
                    }
            } else {
                $("#submit_checkbox").attr("href", _href + dataSent.slice(0, -1));             
                return true;
            }
        });


    });
})(window, document, jQuery);